// Friendly, user-facing labels for the raw camp_reg_transactions / camp_reg_participants
// column names shown in the "Reg Column Name" picker. The picker's underlying VALUE is
// still the raw column name (e.g. "p_email") — this is display-only.
const COLUMN_LABELS = {
  // club_reg_transactions — parent/guardian (primary contact)
  p_first_name: "Parent First Name",
  p_last_name: "Parent Last Name",
  p_email: "Parent Email Address",
  p_cell_phone: "Parent Cell Phone",
  p_home_phone: "Parent Home Phone",
  p_cell_carrier: "Parent Cell Carrier",
  p_relation: "Parent Relation",

  // club_reg_transactions — alternate contact
  a_first_name: "Alternate Contact First Name",
  a_last_name: "Alternate Contact Last Name",
  a_email: "Alternate Contact Email",
  a_cell_phone: "Alternate Contact Cell Phone",
  a_park_id: "Park ID",

  // shared by both tables — contact override fields (emergency contact on the
  // transaction, participant's own contact override on club_reg_participants)
  c_first_name: "Contact First Name",
  c_last_name: "Contact Last Name",
  c_email: "Contact Email",
  c_cell_phone: "Contact Cell Phone",

  // club_reg_transactions — billing
  bill_first_name: "Billing First Name",
  bill_last_name: "Billing Last Name",
  bill_address: "Billing Address",
  bill_city: "Billing City",
  bill_state: "Billing State",
  bill_postal_code: "Billing Zip Code",

  // club_reg_transactions — payment / financial
  registration_name: "Registration Name",
  reg_type: "Registration Type",
  payment_gateway: "Payment Gateway",
  payment_method: "Payment Method",
  transaction_id: "Transaction ID",
  refund_transaction_id: "Refund Transaction ID",
  refund_amount: "Refund Amount",
  authorization_code: "Authorization Code",
  ip_address: "IP Address",
  location_id: "Location ID",
  subtotal: "Subtotal",
  discount_code: "Discount Code",
  discount_amount: "Discount Amount",
  early_reg_discount: "Early Registration Discount",
  late_reg_fee: "Late Registration Fee",
  processing_fee: "Processing Fee",
  total_checkout: "Total Checkout Amount",
  pay_status: "Payment Status",
  waivers: "Waiver Agreements",
  receipt_sequence: "Receipt Sequence",
  receipt_number: "Receipt Number",
  club_id: "Club ID",

  // Forte settlement
  forte_funding_id: "Forte Funding ID",
  forte_settle_date: "Forte Settlement Date",
  forte_settle_batch_id: "Forte Settlement Batch ID",
  forte_settle_amount: "Forte Settlement Amount",
  forte_settle_type: "Forte Settlement Type",
  forte_settled_at: "Forte Settled At",

  // club_reg_participants — participant/camper
  camper_id: "Camper UUID",
  camper_first_name: "Participant First Name",
  camper_last_name: "Participant Last Name",
  camper_age: "Participant Age",
  camper_birthday: "Participant Birthday",
  camper_email: "Participant Email",
  camper_gender: "Participant Gender",
  camper_grade: "Participant Grade",
  camper_street: "Participant Street Address",
  camper_city: "Participant City",
  camper_state: "Participant State",
  camper_zip: "Participant Zip Code",
  camper_t_shirt: "Participant T-Shirt Size",
  camper_health: "Participant Health Notes",
  camper_record: "Participant Records/Notes",
  camper_reg: "Participant Registration ID",
  camper_subtotal: "Participant Fee Subtotal",
  sibling_discount: "Sibling Discount",
  zip_discount: "Zip Code Discount",
  immunization_verified: "Immunization Verified",
  immun_verified: "Immunization Verified (Legacy)",
  low_balance_email_last_sent_at: "Last Low Balance Email Sent",

  // common / shared
  id: "Record ID",
  custom1: "Custom Field 1",
  custom2: "Custom Field 2",
  custom3: "Custom Field 3",
  is_verify: "Verified",
  is_deleted: "Deleted",
};

// Fallback for any column without an explicit mapping: turn snake_case into Title Case
// so new/unmapped columns still read reasonably instead of showing nothing.
const humanize = (fieldName) =>
  String(fieldName)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const getFriendlyColumnLabel = (fieldName) => {
  if (!fieldName) return "";
  return COLUMN_LABELS[fieldName] || humanize(fieldName);
};

export default COLUMN_LABELS;
